import PlayerEquipment from "views/PVE/SteamPlayer/PlayerDetails/components/Summary/components/Equipment";


const prefix="/api/v1/sr";

const atomicwarType = "atomicwar";

const urls={
    login:{
        path:"/admin/login",
        method:"POST",
    },
    refresh:{
        path:"/admin/refresh",
        method:"POST",
    },
    addUser:{
        path:"/admin/user",
        method:"PUT",
    },
    getUser:{
        path:(phone)=>`/admin/user/${phone}`,
        method:"GET",
    },
    getUserLog:{
        path:(phone)=>`/admin/user/${phone}/logs`,
        method:"GET",
    },
    pathUser:{
        path:"/admin/user",
        method:"PATCH",
    },
    deleteUser:{
        path:(id)=>{ return `/admin/user/${id}/delete`;},
        method:"DELETE",
    },
    allUser:{
        path:"/admin/users",
        method:"GET",
    },
    addTodo:{
        path:"/admin/todo",
        method:"POST",
    },
    deleteTodo:{
        path:(name)=>{return `/admin/todo/${name}`;},
        method:"DELETE",
    },
    allTodo:{
        path:"/admin/todo",
        method:"GET",
    },
    roles:{
        path:"/admin/roles",
        method:"GET"
    },
    steamTokens:{
        path:"/admin/steamtokens",
        method:"GET"
    },
    steamTokenDelete:{
        path:"/admin/steamtoken/",
        method:"DELETE"
    },
    steamTokenUpdate:{
        path:"/admin/steamtoken/",
        method:"UPDATE"
    },
    steamplayer:{
        path:(name,pageNum,page,token)=>{ return `/atomicwar/steamplayers?name=${name}&num=${pageNum}&page=${page}&token=${token||""}`;},
        method:"GET"
    },
    steamplayerInfo:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}`;},
        method:"GET"
    },
    steamplayerItem:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}/item`;},
        method:"GET"
    },
    steamplayerPuchase:{
        path:(id)=>{ return `/atomicwar/steamplayer/${id}/purchases`;},
        method:"GET"
    },
    steamplayerPassport:{
        path:(id)=>{ return `/atomicwar/steamplayer/${id}/passports`;},
        method:"GET"
    },
    steamplayerRecharge:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}/recharge` ;},
        method:"GET"
    },
    steamplayerVip:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}/vips` ;},
        method:"GET"
    },
    steamplayerEmoji:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}/emoji` ;},
        method:"GET"
    },
    steamplayerMaster:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}/masters` ;},
        method:"GET"
    },
    steamplayerChickens:{
        path:(id)=>{return `/atomicwar/steamplayer/${id}/chickens` ;},
        method:"GET"
    },
    bannedheroList:{
        path:()=>{return `/atomicwar/bannedhero` ;},
        method:"GET"
    },
    bannedhero:{
        path:(id)=>{return `/atomicwar/bannedhero` ;},
        method:"POST"
    },
    deleteBannedHero:{
        path:(id)=>{return `/atomicwar/bannedhero` ;},
        method:"DELETE"
    },
    deleteBannedItem:{
        path:(id)=>{return `/atomicwar/bannedhero/item/${id}` ;},
        method:"DELTE"
    },
    addBlackList:{
        path: "/atomicwar/blacklist",
        method:"POST"
    },
    getBlackList:{
        path: "/atomicwar/blacklist",
        method:"GET"
    },
    deleteBlackList:{
        path:(id)=>{return `/atomicwar/blacklist/${id}`;},
        method:"DELETE"
    },
    serverWatch:{
        path:(id)=>{return `/admin/serverwatch` ;},
        method:"POST"
    },
    delteserverWatch:{
        path:()=>{return `/admin/serverwatch` ;},
        method:"DELETE"
    },
    getServerWatchStats:{
        path:(id)=>{return `/admin/serverwatch` ;},
        method:"GET"
    },
    getPlayerLogs:{
        path:(id)=>{return `/atomicwar/player/${id}/logs` ;},
        method:"GET"
    },
    getPlayerHistoryLogs:{
        path:(id)=>{return `/atomicwar/player/${id}/historylogs` ;},
        method:"GET"
    },
    rechargeStatistias:{
        path:"/atomicwar/recharge/statistics/",
        method:"GET"
    },
    playerLeaderBoard:{
        path:(ppid)=>{return `/atomicwar/steamplayers/leaderboard/${ppid}`;},
        method:"GET"
    },
    getPpId:{
        path:"/atomicwar/steamplayers/ppid",
        method:"GET"
    },
    playerLevelDetail:{
        path:"/atomicwar/steamplayer/leveldetail",
        method:"GET"
    },
    unhandleorder:{
        path:(start,end)=>{return `/atomicwar/recharge/unhandlerorder?start=${start}&end=${end}` ;},
        method:"GET"
    },
    payserverLogin:{
        path:(id)=>{return `/atomicwar/payserver/gettoken/${id}` ;},
        method:"POST"
    },
    payserverClose:{
        path: "/atomicwar/payserver/shutdown",
        method:"POST"
    },
    getMsgNoticeStatus:{
        path: "/admin/msgstatus",
        method:"GET"
    },
    updatePlayerCntMsgNoticeStatus:{
        path:"/admin/updatemsgstatus/playercnt",
        method:"POST"
    },
    updateDailyIncomeMsgNoticeStatus:{
        path:"/admin/updatemsgstatus/dailyincome",
        method:"POST"
    },
    getActiveCode:{
        path: "/atomicwar/payserver/getactivecode",
        method:"POST"
    },
    getAllGameItem:{
        path: "/atomicwar/gamedata/items",
        method:"GET"
    },
    makeShopTicket:{
        path: "/atomicwar/payserver/shopticket",
        method:"POST"
    }, 
    getAllTickets: {
        path: "/atomicwar/shop/tickets",
        method: "GET"
      },
    queryShopTicket:{
        path:(id)=>  `/admin/payserver/shopticket/${id}`,
        method:"GET"
    },
    closeVerifyCode:{
        path: "/admin/verifycode/status",
        method:"GET"
    }, 
    clearPlayerRedisCache:{
        path:(id)=> `/atomicwar/steamplayer/${id}/clearcache`,
        method:"GET"
    }, 
    recentlyOrder:{
        path:"/atomicwar/recharge/recently",
        method:"GET"
    }, 
    takeShopTicket:{
        path:"/atomicwar/gameserver/shopticket",
        method:"POST"
    }, 
    batchFixed:{
        path:(func)=>`/atomicwar/gameserver/${func}`,
        method:"POST"
    }, 
    crDailyReport:{
        path:(start,end)=>`/atomicwar/statis/dailyreport?start=${start}&end=${end}`,
        method:"GET"
    }, 
    shopDailyReport:{
        path:(start,end)=>`/atomicwar/statis/shopdailyreport?start=${start}&end=${end}`,
        method:"GET"
    },
    deletePlayer:{
        path:(id)=> `/atomicwar/steamplayer/${id}`,
        method:"DELETE"
    },
    postRankListOperation:{
        path:"/atomicwar/dy/status",
        method:"POST"
    },
    getRankListOperation:{
        path:"/admin/dy/status",
        method:"GET"
    },
    deleteRankList:{
        path:"/atomicwar/dy/leaderboard",
        method:"DELETE"
    },
    dyLeaderBoard:{
        path:"/atomicwar/dy/leaderboard",
        method:"GET"
    },
    deleteLeaderBoard:{
        path:(id) => `/atomicwar/steamplayer/leaderboard/${id}`,
        method:"DELETE",
    },
    payOrders :{
      path:(start,end,page) => `/atomicwar/pay/orders?start=${start}&end=${end}&page=${page}`,
      method:"GET",
    },
    resendOrder:{
      path:"/atomicwar/pay/resend",
      method:"POST",
    },
    resendPaypalOrder:{
      path:"/atomicwar/pay/paypal/webhook/resend",
      method:"POST",
    },
    getClientIps:{
      path:"/atomicwar/clientips",
      method:"GET",
    },
    getSystemLogs:{
      path:"/admin/systemlogs",
      method:"GET",
    }, 
    shopItems:{
      path:"/atomicwar/recharge/cashitems",
      method:"GET",
    },
    briefInfo:{
      path:(id)=>(`/atomicwar/player/brief/${id}`),
      method:"GET",
    },
    playerQuests:{
      path:(id)=>(`/atomicwar/player/quests/${id}`),
      method:"GET",
    },
}

export {prefix,urls,atomicwarType}
